import { Components } from "@thisgorilla/primate-ds";
import { ListItemProps } from "@thisgorilla/primate-ds/dist/components/ListItem";
import { FlexColumn } from "../../../../Common/Styles";

type ListItem = ListItemProps.IProps;
export const RecommendedPods = () => {
  const commonProps = {
    type: "List Item",
    onClick: () => {},
    selected: false,
    iconType: "Users",
    showRightButton: true,
    rightButtonLabel: "Join",
    rightButtonOnClick: () => {},
  } as const;
  const option1: ListItem = { label: "Startup Club ZA", ...commonProps };
  const option2: ListItem = { label: "Figma", ...commonProps };
  const option3: ListItem = {
    label: "Product Design Worldwide",
    ...commonProps,
  };

  return (
    <FlexColumn $gapInPx={8}>
      <Components.Label text="Recommended" kind="Fill" color="Dark" />
      <FlexColumn $gapInPx={0}>
        {[option1, option2, option3].map((listItem, i) => (
          <Components.ListItem {...listItem} key={i} />
        ))}
      </FlexColumn>
      <Components.ListItem
        type="Button"
        IconType="ChevronDown"
        onClick={() => {}}
        label="Show more"
      />
    </FlexColumn>
  );
};
